import { useEffect } from 'react';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface WizardSuccessProps {
  title: string;
  message?: string;
  onDone: () => void;
  autoCloseMs?: number;
  variant?: 'success' | 'info';
}

export function WizardSuccess({
  title,
  message,
  onDone,
  autoCloseMs = 2000,
  variant = 'success',
}: WizardSuccessProps) {
  useEffect(() => {
    if (autoCloseMs > 0) {
      const timer = setTimeout(onDone, autoCloseMs);
      return () => clearTimeout(timer);
    }
  }, [autoCloseMs, onDone]);

  const bgColor = variant === 'success' ? 'bg-green-500' : 'bg-blue-500';

  return (
    <div className="py-8 text-center">
      <div
        className={cn(
          'w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center',
          'animate-in zoom-in-50 duration-300',
          bgColor
        )}
      >
        <Check className="w-8 h-8 text-white" />
      </div>
      <h3 className="text-lg font-semibold text-slate-100 mb-2 animate-in fade-in-0 duration-500 delay-150">
        {title}
      </h3>
      {message && (
        <p className="text-sm text-slate-400 animate-in fade-in-0 duration-500 delay-300">
          {message}
        </p>
      )}
    </div>
  );
}
